import { render } from "./ProposalFieldValue.vue?vue&type=template&id=788736a6&scoped=true&ts=true"
import script from "./ProposalFieldValue.vue?vue&type=script&lang=ts"
export * from "./ProposalFieldValue.vue?vue&type=script&lang=ts"

import "./ProposalFieldValue.vue?vue&type=style&index=0&id=788736a6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788736a6"]])

export default __exports__